/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import SidebarSectionTitle from './SidebarSectionTitle'

import styled from '@emotion/styled'


const StyledSection = styled('section')`
  font-family: ${({ theme }) => theme.fonts.light};
  &:first-child h2 {
    margin-top: 0;
  }

  @media only screen and (max-width: 767px) {
    display: flex;
    flex-flow: row wrap;
  }

  @media only screen and (min-width: 768px) {
    margin: 24px 0 0;
  }
`

const SidebarSection = ({ children, title, ...rest }) => (
  <StyledSection {...rest}>
    {title && typeof title === 'string' ? (
      <SidebarSectionTitle>{title}</SidebarSectionTitle>
    ) : (
      title
    )}
    {children}
  </StyledSection>
)

SidebarSection.propTypes = {
  children: PropTypes.any,
  title: PropTypes.node,
}

export default SidebarSection
